import noUiSlider from "nouislider";
import wNumb from "wnumb/wNumb.js";

/**
 * Docs: https://refreshless.com/nouislider/
 * Example Preis: stoffe-und-naehzubehoer/buegeleisen/?pfrom=20&pto=500
 * Example Zeit: ideen-und-anleitungen/basteln-mit-kindern/?o=&zfrom=10.00&zto=720.00
 */

export default class EtRangeSlider {

    /**
     *
     * @param rangeSliderElement
     * @param min minimaler Startwert
     * @param max maximaler Endwert
     * @param prefix
     * @param postfix
     * @param selectedStart ausgewählter Startwert
     * @param selectedEnd ausgewählter Endwert
     */
    constructor(
        rangeSliderElement?: HTMLElement|null,
        min: number = 0,
        max: number = 9999,
        prefix: string = "",
        postfix: string = "",
        selectedStart?: number,
        selectedEnd?: number
    ) {
        if (rangeSliderElement instanceof HTMLElement) {
            this.initRangeSlider(rangeSliderElement, min, max, prefix, postfix, selectedStart, selectedEnd);
        }else{
            // auto-init all RangeSliders
            this.initRangeSliders();
        }
    }

    private initRangeSlider(rangeSliderElement: HTMLElement, min: number, max: number, prefix: string, postfix: string, selectedStart?: number, selectedEnd?: number) {

        //Doppelte Initialisierung verhindern
        if (rangeSliderElement.dataset.initialized === "true") {
            return this.getRangeSlider(rangeSliderElement);
        }

        if(!selectedStart) selectedStart = min;
        if(!selectedEnd) selectedEnd = max;

        // Breite wird über den übergeordneten Container gesteuert
        rangeSliderElement.style.width = "80%";
        rangeSliderElement.style.margin = "0 auto";

        noUiSlider.create(rangeSliderElement, {
            start: [selectedStart, selectedEnd],
            connect: true,
            step: 1,
            behaviour: "tap-drag",
            range: {
                "min": min,
                "max": max
            },
            pips: {
                mode: "positions",
                values: [0, 100],
                density: 4,
                stepped: false,
                format: wNumb({
                    decimals: 0,
                    prefix: prefix,
                    postfix: postfix
                })
            },
            tooltips: wNumb({
                decimals: 0,
                prefix: prefix,
                postfix: postfix
            }),
        });

        rangeSliderElement.setAttribute("data-initialized", "true");
    }

    /**
     * Alle RangeSlider initialisieren
     * @private
     */
    private initRangeSliders() {
        document.querySelectorAll(".etRangeSlider").forEach((rangeSliderElement) => {
            if (rangeSliderElement instanceof HTMLElement) {
                const min = parseFloat(rangeSliderElement.dataset.min || "0");
                const max = parseFloat(rangeSliderElement.dataset.max || "9999");
                const prefix = rangeSliderElement.dataset.prefix || "";
                const postfix = rangeSliderElement.dataset.postfix || "";
                const start = parseFloat(rangeSliderElement.dataset.start || "0");
                const end = parseFloat(rangeSliderElement.dataset.end || "9999");
                this.initRangeSlider(rangeSliderElement, min, max, prefix, postfix, start, end);

                // wenn es passende inputs gibt, dann werden diese mit dem slider synchronisiert
                if (rangeSliderElement.dataset.targetForm) {
                    const targetForm = document.getElementById(rangeSliderElement.dataset.targetForm);
                    const form_from = targetForm?.querySelector(".range_slider_from");
                    const form_to = targetForm?.querySelector(".range_slider_to");
                    if (
                        !(form_from instanceof HTMLInputElement) 
                            || !(form_to instanceof HTMLInputElement)
                            || !(targetForm instanceof HTMLFormElement)
                    ) {
                        return;
                    }

                    rangeSliderElement.noUiSlider.on("set", (a, b, c, d, e, f) => {
                        const minValue = parseInt(f.target.dataset.min);
                        const maxValue = parseInt(f.target.dataset.max);
                        const oldFromValue = parseInt(form_from.value);
                        const newFromValue = parseInt(rangeSliderElement.noUiSlider.get()[0]);
                        const oldToValue = parseInt(form_to.value);
                        const newToValue = parseInt(rangeSliderElement.noUiSlider.get()[1]);
                        if (oldFromValue != newFromValue) {
                            form_from.value = newFromValue.toString();
                            const event = new Event("update");
                            form_from.dispatchEvent(event);
                        }
                        if (oldToValue != newToValue) {
                            form_to.value = newToValue.toString();
                            const event = new Event("update");
                            form_to.dispatchEvent(event);
                        }
                    });

                    form_from.addEventListener("change",  () => {
                        rangeSliderElement.noUiSlider.set([this.value, null]);
                    });

                    form_to.addEventListener("change",  () => {
                        rangeSliderElement.noUiSlider.set([null, this.value]);
                    });

                    targetForm.addEventListener("reset",  () => {
                        rangeSliderElement.noUiSlider.set([min, max]);
                        form_from.setAttribute("value", String(min));
                        form_to.setAttribute("value", String(max));
                    });
                }
            }
        });

        /**
         * Bugfix: Dropdowns schließen sich bei Klick auf dropdown
         */
        document.querySelectorAll(".element_narrower__top_default_dropdown").forEach((dropdown) => {
            dropdown.addEventListener("click", (e) => {
                e.stopPropagation();
            });
        });
    }

    public getRangeSlider(sliderElement: HTMLElement) {
        return sliderElement.noUiSlider.get();
    }

    private obfuscateAndSubmitUrl(url: string, target_form: HTMLFormElement) {
        const parseQueryParams = (query: string) =>
            query.split("&").reduce((obj: {[key: string]: string}, item) => {
                const [key, value] = item.split("=");
                obj[key] = decodeURIComponent(value);
                return obj;
            }, {});

        const queryParams = parseQueryParams(location.search.substring(1));

        const filteredParams = Object.entries(queryParams).filter(([key]) => key !== "pto" && key !== "pfrom");

        filteredParams.forEach(([key, value]) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = value;
            target_form.appendChild(input);
        });

        const characters = "!\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~";
        const replacement = "PQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~!\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNO";

        const obfuscatedUrl = url
            .split("")
            .map(char => {
                const index = characters.indexOf(char);
                return index !== -1 ? replacement[index] : char;
            })
            .join("");

        document.getElementById("prg-input")?.setAttribute("value", obfuscatedUrl);
        document.getElementById("prg-form")?.submit();
    }
}